import client from '../../client'

export interface Params {
  code?: string
  code2?: string
}

export interface Data {
  user: {
    name1: string
    name2: string
    kana1: string
    kana2: string
    sex: number | null
    birthdayYear: string
    birthdayMonth: string
    zip: string
    prefecture: number | null
    address1: string
    address2: string
    addressOther: string
    tel: string
    highSchPrefecture: number | null
    highSchNpp: number | null
    highSchName: string
    grade: number | null
    email: string
    hopeCourse: number | null
    hopeDepart1: number | null
    hopeDepart2: number | null
    hopeArea: number | null
  }
  cart: string[] /** 学校IDの配列 e.g. ['D100001'] */
}

export type Response = {
  result: {
    /**
     * 次のキャンペーンコード
     *
     * 続けて資料請求させる場合の次のキャンペーンコード。
     *
     * **⚠string型ではなくnumber型なので注意。**
     */
    relInputCode: number
    /**
     * 次のキャンペーン名
     *
     * 続けて資料請求させる場合の次のキャンペーン名。
     */
    serviceName: string
    /**
     * ローカルに保持しているユーザー情報を削除するか否か
     *
     * 続けて資料請求させる場合はユーザー情報を削除しない。
     */
    removeUser: boolean
  }
}

export async function set(data: Data, params: Params) {
  return client.post<Response>('set_request_appli_data', { form: data }, { params }).then(({ data }) => data)
}
